import { lazy } from "react";
import { useRoutes } from "react-router-dom";
import ProtectedRoutes from "routes/ProtectedRoutes";
import PassengerCurrentTripStoreProvider from "./PassengerCurrentTripStoreProvider";
import {
  Passenger_CurrentTrip_Route,
  Passenger_Dispatch_Route,
  Passenger_Index_Route,
  Passenger_Payment_Route,
  Passenger_PrePaymentReserve_Route,
  Passenger_Reserves_Route,
  Passenger_Survey_Route,
  Passenger_TripDetail_Route,
  Passenger_TripHistory_Route,
} from "./routesVar";

const MainLayout = lazy(() =>
  import("shared/layout/mainLayout").then((module) => ({
    default: module.default,
  }))
);

const TaxiRequest = lazy(() =>
  import("pages/passenger/request/home").then((module) => ({
    default: module.TaxiRequest,
  }))
);

const TripHistory = lazy(() =>
  import("pages/passenger/tripHistory/view").then((module) => ({
    default: module.TripHistory,
  }))
);

const CurrentTrip = lazy(() =>
  import("pages/passenger/currentTrip").then((module) => ({
    default: module.CurrentTrip,
  }))
);

const Survey = lazy(() =>
  import("pages/passenger/survey").then((module) => ({
    default: module.Survey,
  }))
);

const TripDetail = lazy(() =>
  import("pages/passenger/tripDetail").then((module) => ({
    default: module.TripDetail,
  }))
);

const DispatchRequest = lazy(() =>
  import("pages/passenger/request/components/Dispatch/dispatch").then(
    (module) => ({
      default: module.DispatchRequest,
    })
  )
);

const PassengerReservedSales = lazy(() =>
  import("pages/passenger/reservedSales").then((module) => ({
    default: module.PassengerReservedSales,
  }))
);
const PaymentModal = lazy(() =>
  import("pages/passenger/currentTrip/components/paymentModal").then(
    (module) => ({
      default: module.PaymentModal,
    })
  )
);
const PrePaymentReserve = lazy(() =>
  import("pages/passenger/reservedSales/components/prePaymentReserve").then(
    (module) => ({
      default: module.PrePaymentReserve,
    })
  )
);

export const PassengerRoutes = () =>
  useRoutes([
    {
      element: <PassengerCurrentTripStoreProvider />,
      children: [
        {
          element: <ProtectedRoutes />,
          children: [
            {
              element: <MainLayout />,
              children: [
                {
                  path: Passenger_Index_Route,
                  element: <TaxiRequest />,
                },
                {
                  path: Passenger_Dispatch_Route,
                  element: <DispatchRequest />,
                },
                {
                  path: Passenger_TripHistory_Route,
                  element: <TripHistory />,
                },
                {
                  path: Passenger_Survey_Route,
                  element: <Survey />,
                },
                {
                  path: Passenger_TripDetail_Route,
                  element: <TripDetail />,
                },
                {
                  path: Passenger_Reserves_Route,
                  element: <PassengerReservedSales />,
                },
                {
                  path: Passenger_CurrentTrip_Route,
                  element: <CurrentTrip />,
                },
                {
                  path: Passenger_Payment_Route,
                  element: <PaymentModal />,
                },
                {
                  path: Passenger_PrePaymentReserve_Route,
                  element: <PrePaymentReserve />,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      element: <></>,
      path: "*",
    },
  ]);
